import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import NewsletterLayer from "../components/NewsletterLayer";

const NewsletterPage = () => {
     return (
          <>
               {/* MasterLayout */}
               <MasterLayout>
                    {/* Breadcrumb */}
                    <Breadcrumb title="Newsletter Subscribers" />

                    {/* TermsConditionLayer */}
                    <NewsletterLayer />
               </MasterLayout>
          </>
     );
};

export default NewsletterPage;
